// Generated by ReScript, PLEASE EDIT WITH CARE

import * as WebSdk from "@vindral/web-sdk";

var _map = {"playing":"playing","buffering":"buffering","paused":"paused"};

function playbackStateToJs(param) {
  return param;
}

function playbackStateFromJs(param) {
  return _map[param];
}

function create(config) {
  return new WebSdk.Vindral(config);
}

export {
  playbackStateToJs ,
  playbackStateFromJs ,
  create ,
}
/* @vindral/web-sdk Not a pure module */
